/* todo: jain, mobe to top level and rename to index and filter component */import './styles.scss';
import React, {useCallback, useEffect, useState} from "react";

/* Types, Constants, Utils */
import {TFilter, TFilterOption, TFilterPivot} from "../../../types/search";

/* Bootstrap */
import {Accordion, Button} from "react-bootstrap";
import {FormCheckType} from "react-bootstrap/FormCheck";

/* Components */
import FiltersCheck from "../filters-check";
import FiltersCascade from "../filters-cascade";
import {ISearchState} from "../../../types/redux/search";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux";

interface IProps {
  filter: TFilter;
  filterIndex: number;
  opened: boolean;
  handleToggleItem(key: string):void;
  handleExpand(filterEntry: TFilter, index: number, value: boolean): void;
}

const INITIAL_OPTIONS_COUNT: number = 9;

const FiltersFilter = (props: IProps):JSX.Element => {
  const {
    filter,
    filterIndex,
    opened,
    handleToggleItem,
    handleExpand
  } = props;

  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);
  const [selectedCount, setSelectedCount] = useState<number>(0)

  useEffect(()=>{
    const getSelectedOptionsCnt = (_filterOptions: TFilterOption[]): number =>{
     const selectedOptions: string[] = searchState.selected_filters_ids.filter(id=> {
       const isSubordonateFilter: TFilterOption | undefined = _filterOptions.find(fo=>fo.id === id);
       return isSubordonateFilter !== undefined
     });
     return selectedOptions.length;
    }

    let _selectedCount: number = 0
    if (filter.pivot_options) {
      filter.pivot_options.forEach(po=>{
        if (po.options.length > 0) {
          _selectedCount += getSelectedOptionsCnt(po.options)
        }
      })
    } else {
      _selectedCount = getSelectedOptionsCnt(filter.options);
    }
    setSelectedCount(_selectedCount);

  }, [searchState.selected_filters_ids, filter])

  useEffect(()=>{
    if (filter.initially_opened && !opened) {
      handleToggleItem(filter.id)
    }
  }, [opened, filter.initially_opened, filter.id, handleToggleItem])

  const filterOptionElems = useCallback((options: TFilterOption[], onHandleChange: any = null): JSX.Element => {
    return (<>
      {options.map((filterOption: TFilterOption, index: number) =>{
        if ((index <= INITIAL_OPTIONS_COUNT) || (filter.expanded)) {

          /* Check or Toggle switch filter option */
          return <FiltersCheck
              key={filterOption.id + '_fc'}
              type={filter.type as FormCheckType}
              onHandleChange={onHandleChange}
              filterOption={filterOption}/>

        } else if ((index === (INITIAL_OPTIONS_COUNT + 1)) && (!filter.expanded)) {

          /* show more - expand button */
          return (<Button
            key={filter.id + index + '_expand'}
            className={'more-less-link btn-link text-primary ms-4 p-0'}
            onClick={e=>handleExpand(filter, filterIndex, true)}
          >
            + {options.length - INITIAL_OPTIONS_COUNT + 1} more
          </Button>)

        } else {
          /* unexpanded -  hidden items */
          return <div key={filter.id + index} className={'hidden'}></div>
        }
      })}
    </>)
  }, [filter, filterIndex, handleExpand])

  return (
    <Accordion.Item
      key={filter.id + '_item'}
      eventKey={filter.id}
      className={'filters-filter border-0 p-0'}
    >
      <Accordion.Header
        key={filter.id + '_header'}
        className={'py-3 px-1 text-smaller'  + (opened ? '' : ' border-bottom')}
        onClick={e=>handleToggleItem(filter.id)}
      >
        <b>{filter.heading} {(selectedCount > 0) &&
          <div className={'filter-count d-inline-block bg-primary rounded-circle text-white text-xs ms-1'
            + (selectedCount > 9 ? ' double-digit':'')}>
            {selectedCount}
          </div>}
        </b>
      </Accordion.Header >

      <Accordion.Body key={filter.id + '_body'} className={'p-0 pb-3 border-bottom'}>
        {/* filter options */}
        {filter.options &&
          <div className={'mx-4'}>
            {filterOptionElems(filter.options)}
          </div>}

        {/* or pivot options */}
        {filter.pivot_options &&
          filter.pivot_options.map((pivotFilter:TFilterPivot, index:number) => {
            return(
              <div key={'pf_' + index}>
                {filter.pivot_expandable &&
                  <FiltersCascade
                    filterOptionElems={filterOptionElems}
                    pivotFilter={pivotFilter}/>}

                {!filter.pivot_expandable &&
                  <>
                    <p className={'text-smaller m-0 p-0 ms-4 mb-2 '}> <b>{pivotFilter.value}</b></p>
                    <div className={'ps-4'}>{filterOptionElems(pivotFilter.options)}</div>
                  </>}
              </div>
            )
          })
        }

        {/* less button */}
        {filter.expanded &&
          <Button
            className={'more-less-link btn-link text-primary ms-4 p-0 mb-3'}
            onClick={e=> handleExpand(filter, filterIndex, false)}
          >
            less
          </Button>}

      </Accordion.Body>
    </Accordion.Item>
  )
}
export default FiltersFilter;
